import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss'],
  animations: [
      trigger('base-modal', [
          transition('void => *', [
              style({ transform: 'scale3d(.3, .3, .3)' }),
              animate(100)
          ]),
          transition('* => void', [
              animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
          ])
      ])
  ]
})
export class BaseModalComponent implements OnInit {

  @Input() visible: boolean;
  @Input() ready: boolean;
  @Input() closable = true;
  @Input() type: string;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  closeModal(event) {
      this.visible = false;
      this.visibleChange.emit(this.visible);
  }
}
